import React from 'react';

import {
  STATISTICS_ORDERS as FILTERS_STATISTICS_ORDERS,
} from '../../orders/filters';

import createChartGroup from '../createChartGroup';

import {
  Groups,
  GroupsWrapper,
  GroupsError,
  GroupsLoading,
} from '../../../components/Statistics';

import {
  filterCompare,
} from '../filters';

const GROUPS = [{
  id: 'categories',
  title: 'Categories',
  maxItems: 10,
  sorts: [
    'default',
    'valueDsc',
    'valueAsc',
  ],
  charts: [{
    id: 'categoriesPerOrders',
    label: 'Orders',
    precision: 0,
    title: 'Number of times product category was ordered.',
  }, {
    id: 'categoriesPerQuantity',
    label: 'Quantity',
    precision: 0,
    title: 'Total quantity sold per category.',
  }, {
    id: 'categoriesPerRevenue',
    label: 'Revenue',
    title: 'Total revenue earned by category.',
  }],
}, {
  id: 'collections',
  title: 'Collections',
  maxItems: 10,
  sorts: [
    'default',
    'valueDsc',
    'valueAsc',
  ],
  charts: [{
    id: 'collectionsPerOrders',
    label: 'Orders',
    precision: 0,
    title: 'Number of times product collection was ordered.',
  }, {
    id: 'collectionsPerQuantity',
    label: 'Quantity',
    precision: 0,
    title: 'Total quantity sold per collection.',
  }, {
    id: 'collectionsPerRevenue',
    label: 'Revenue',
    title: 'Total revenue earned by collection.',
  }],
}, {
  id: 'products',
  title: 'Products',
  maxItems: 10,
  sorts: [
    'default',
    'valueDsc',
    'valueAsc',
  ],
  charts: [{
    id: 'productsByOrders',
    label: 'Orders',
    precision: 0,
    title: 'Number of times product was ordered.',
  }, {
    id: 'productsByQuantity',
    label: 'Quantity',
    precision: 0,
    title: 'Total quantity sold per product.',
  }, {
    id: 'productsByRevenue',
    label: 'Revenue',
    title: 'Total revenue earned per product.',
  }],
}].map(group => createChartGroup(group));

export default ['PageStatistics', {
  id: 'statistics-products',
  title: 'Products',
  label: 'Products',
  path: '/analytics/products',
  loadUrl: '/statistics/products',
  getUseFiltersExtra: () => true,
  redirect: [['redirect.unauthorized']],
  filters: [
    filterCompare,
    ...FILTERS_STATISTICS_ORDERS.map(a => ([a[0], {
      ...a[1],
      // isExtra: false,
      whereSide: 'where',
    }])),
    ...FILTERS_STATISTICS_ORDERS.map(a => ([a[0], {
      ...a[1],
      id: a[1].id === 'store' ? a[1].id : `b.${a[1].id}`,
      // isExtra: false,
      section: 'topCompare',
      whereSide: 'whereB',
      skip: [
        ...(a[1].skip || []),
        props => !['1', '2'].includes(`${props.searchParams.compare}`),
      ],
    }])),
  ],
  renderStats: (props) => {
    if (!props.data && props.loading) {
      return (
        <GroupsWrapper>
          <GroupsLoading />
        </GroupsWrapper>
      );
    }
    if (props.error?.response?.data?.meta?.missingStore) {
      return (
        <GroupsWrapper style={{
          opacity: 0.5,
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
        >
          <GroupsError
            title="Please select a store first"
            style={{ zoom: 0.95 }}
          />
        </GroupsWrapper>
      );
    }
    if (!props.data || !props.data.data) {
      return (
        <GroupsWrapper />
      );
    }
    return (
      <GroupsWrapper loading={props.loading}>
        <Groups {...props} groups={GROUPS} />
      </GroupsWrapper>
    );
  },
}];
